import { useMutation } from "@tanstack/react-query";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://insightpanel.sembian.net";

const submitContact = async (data) => {
    const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    
    let responseData;
    try {
        responseData = await response.json();
    } catch (e) {
        throw new Error('Failed to parse server response');
    }
    
    if (!response.ok) {
        const errorMessage = responseData.message || responseData.error || `Server error: ${response.status}`;
        throw new Error(errorMessage);
    }
    
    return responseData;
};

export const useContactMutation = (options = {}) => {
    return useMutation({
        mutationFn: (data) => submitContact(data),
        onSuccess: (data) => {
            console.log('Contact form submitted successfully', data);
            if (options.onSuccess) {
                options.onSuccess(data);
            }
        },
        onError: (error) => {
            console.error('Contact form submission error:', error);
            if (options.onError) {
                options.onError(error);
            }
        },
    });
};